import React, { Component, createRef } from 'react';
import { Input } from '@vds/inputs';
import { Body } from '@vds/typography';
import { RadioButtonGroup, CheckboxGroup } from '@vds/inputs';
import { Grid, Row, Col } from '@vds/grids';
import { Button } from '@vds/buttons';
import { isAlpha} from '../../../utils/common';
import { MarginSpacerM } from '../../Checkout/styleTag';
import './ContactUs.css';
import { Feature } from '@vds/typography/dist/cjs/components/Feature';
import { TextArea } from '@vds/inputs/dist/cjs/components/TextArea';
import { connect } from 'react-redux';
import {SubmitIdeForm, showSpinner} from '../../AddressValidationPage/containers/action'
import TextLinkCaret from '@vds/buttons/dist/cjs/components/TextLinkCaret';
import { Link } from 'react-router-dom';
import Title from '@vds/typography/dist/cjs/components/Title/Title';
import * as action from '../containers/action';
import { bindActionCreators } from 'redux';
import SpinnerComponent from '../../../Common/Spinner/Spinner';
import { DropdownSelect } from '@vds/selects';
import { isMobile } from 'react-device-detect';
import { TextLink } from '@vds/buttons';

class ContactUs extends Component {
    constructor(props) {
        super(props);
        this.state = {
            contactInformation: {
                firstName: '',
                lastName: '',
                Phone: this.props?.addressData?.phoneNumber ? this.props?.addressData?.phoneNumber : '',
                Email: this.props?.addressData?.emailAddress ? this.props?.addressData?.emailAddress : '',
                MobilePhone: "",
                Address: this.props?.addressData?.selectedStreetAddress?.dispstr ? this.props?.addressData?.selectedStreetAddress?.dispstr +` `+ (this.props?.addressData?.biilingselectedUnit ? this.props?.addressData?.biilingselectedUnit?.unit : '') : '',
                City: this.props?.addressData?.selectedStreetAddress ? this.props?.addressData?.selectedStreetAddress?.muni : '',
                PostalCode:this.props?.addressData?.selectedStreetAddress ? this.props?.addressData?.selectedStreetAddress?.zip : '',
                State: this.props?.addressData?.selectedStreetAddress ? this.props?.addressData?.selectedStreetAddress?.state : '',
                Description:"Online Customer Webform Submission. HOT IDE Lead, please contact within the next 24 hours.",
                Country: "usa",
                Company: '',
                Status: "NEW",
                LeadSource: "Digital Ads/Content",
                Title: "Vice President",
                Industry: "",
                Website: "",
                Account: "",
                External_System_Lead_ID: this.props?.addressData?.addressQualificationDetails?.sessionId ? this.props?.addressData?.addressQualificationDetails?.sessionId : '',
                NASP_IDs_Text: "",
                Products_of_Interest: "",
                Campaign_Name: "CAM-0043988",
                Target_Lead_Owner: "",
                External_Lead_Source_System: "IDE"
                
            },
            errorTexts: {
                contactInformation: {
                    fName: '',
                    lName: '',
                    cPhoneNumber: '',
                    cEmail: '',
                    cAddress: '',
                    cState: '',
                    cZip: '',
                    cCity: '',
                    cEmail:'',
                    cBusinessName: '',
                    cComment:'',
                    cIndustry:'',
                    cPreference:'',
                    cCountry:'',
                },
            },
            confirmCheckbox: false,
            spinnerOn: false,
        };
        window.scrollTo(0, 0);
    }

    isValidContactUsInfoField(key, val) {
        let { errorTexts } = this.state;
        let value = val;

        // firstName
        if (key === "firstName") {
            errorTexts.contactInformation['fName'] = !value.trim() ? "First name must be entered." : "";
        }

        // lastName
        if (key === "lastName") {
            errorTexts.contactInformation['lName'] = !value.trim() ? "Last name must be entered." : "";
        }

        // Phone
        if (key === "Phone") {
            // const Phone = value.replace(/[^\d]/g, "");

            // if (/^[0-9]{0,10}$/.test(Phone)) {
            //     value = Phone.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
            // }

            // if (!value.trim()) {
                // errorTexts.contactInformation['cPhoneNumber'] = "Phone number must be entered.";
                errorTexts.contactInformation['cPhoneNumber'] = !value.trim() ? "Phone number must be entered." : '';
            } 
            // else {
            //     const pattern = /^\d{10}$/;
            //     if (!pattern.test(Phone)) {
            //         errorTexts.contactInformation['cPhoneNumber'] = "Phone number must be 10 digits.";
            //     } else {
            //         errorTexts.contactInformation['cPhoneNumber'] = "";
            //     }
            // }
        // }

        // Email
        if (key === "Email") {
            if (!value.trim()) {
                errorTexts.contactInformation['cEmail'] = "Email must be entered."
            } else {
                const pattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

                if (!pattern.test(value)) {
                    errorTexts.contactInformation['cEmail'] = "Please enter your valid Email Address."
                } else {
                    errorTexts.contactInformation['cEmail'] = '';
                }
            }
        }

        // Company
        if (key === "Company") {
            errorTexts.contactInformation['cBusinessName'] = !value.trim() ? "Business name must be entered." : "";
        }

        // Address
        // if (key === "Address") {
        //     errorTexts.contactInformation['cAddress'] = !value.trim() ? "Address must be entered." : "";
        // }
        // City
        // if (key === "City") {
        //     errorTexts.contactInformation['cCity'] = !value.trim() ? "City must be entered." : "";
        // }
        // state
        // if (key === "Country") {
        //     errorTexts.contactInformation['cCountry'] = !value.trim() ? "Country must be Entered." : "";
        // }
        // zip code
        // if (key === "Zip") {
        //     errorTexts.contactInformation['cZip'] = !value.trim() ? "Zip must be entered." : "";
        // }

        // if (key === "Industry") {
        //     errorTexts.contactInformation['cIndustry'] = !value.trim() ? "Industry must be entered." : "";
        // }

        if (key === "Preference") {
            errorTexts.contactInformation['cPreference'] = !value.trim() ? "Please select a preference." : "";
        }

        

        // const iscontactInformationValid = this.isValidInfoEntered(errorTexts.contactInformation);

        this.setState({
            contactInformation: { ...this.state.contactInformation, [key]: value },
            errorTexts
        })
    }

    isValidInformationEntered(errorTexts) {
        const keys = Object.keys(errorTexts);
        for (let i = 0; i < keys.length; i++) {
            if (errorTexts[keys[i]]) {
                return false;
            }
        }
        return true;
    }

    isValidContactUsInformation() {
        const contactInformation = this.state.contactInformation;
        const errorTexts = this.state.errorTexts.contactInformation;
        const keys = Object.keys(contactInformation);

        for (let i = 0; i < keys.length; i++) {
            this.isValidContactUsInfoField(keys[i], contactInformation[keys[i]]);
        }

        return this.isValidInformationEntered(errorTexts);
    }

    onContinueClick = () => {
        const params = this.state.contactInformation;
        const history = this.props.history;
        const validation = this.isValidContactUsInformation();
       if(validation){
           const payload = {Req: [params]};
        this.props.action.SubmitIdeForm(payload,history);
        this.setState({spinnerOn : true});
        // setTimeout(() => {
        //     this.props.showSpinner(true);
        // }, 5000 );
        // this.props.history.push("/Thank-you");
       }
    }

    render() {
        return (
            <div className="business-information-container" style={{marginTop: '40px'}}>
                <Grid colSizes={{ mobile: 6, tablet: 10, desktop: 12 }}>
                <Row>
                            <Col colSizes={{ mobile: 4, tablet: 10, desktop: 10 }}>
                                {this.props?.toggleLoadingSpinner && this.state.spinnerOn ? <SpinnerComponent /> : ''}
                            </Col>
                        </Row>
                <Row>
                            <Col colSizes={{ mobile: 4, tablet: 10, desktop: 12 }}>
                                <div className="continue-btn" style={{marginTop:'5px'}}>
                                <Link to="/internet-services">
								<TextLinkCaret iconPosition="left">Go back</TextLinkCaret>
							    </Link>
                                </div>
                            </Col>
                </Row>
                        <Row>
                            <Col colSizes={{ mobile: 6, tablet: 10, desktop: 12 }}>
                               <div className="mtb1-contact-desc">
                               <Title size="large" primitive="h2">
                                 <span> Your location qualifies for {!isMobile ? <br/> : <></>} Verizon Internet Dedicated Services.</span>
                            </Title>
                                        
                                </div>
                            </Col>
                        </Row>

                        <Row>
                            <Col colSizes={{ mobile: 6, tablet: 10, desktop: 7 }}>
                                <div className="mtb1-contact-desc">
                                    <Body size="medium" primitive="h2">
                                    Internet Dedicated Services uses ultrafast, full-duplex connections to deliver scalable internet connectivity. It can help you support high-bandwidth applications,
easily share information and enable high-speed transactions. Burstable and tiered pricing options help you dial up bandwidth with demand.
										</Body>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col colSizes={{ mobile: 6, tablet: 10, desktop: 7 }}>
                                <div className="mtb1-contact-desc">
                                    <Body size="medium" primitive="h2">
                                    Enter your contact information below and a Sales representative will reach out to you as soon as possible.              
										</Body>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col colSizes={{ mobile: 4, tablet: 4, desktop: 3 }}>
                                <div  className="left-input-box-contact  mtb1-contact">
                                    <Input
                                        className="input-contact"
                                        label="First Name"
                                        name="firstName"
                                        width={'100%'}
                                        value={this.state.contactInformation.firstName}
                                        onChange={(e) => this.isValidContactUsInfoField('firstName', e.target.value)}
                                        error={!!this.state.errorTexts.contactInformation.fName}
                                        errorText={this.state.errorTexts.contactInformation.fName}
                                    />
                                </div>
                            </Col>
                            <Col colSizes={{ mobile: 4, tablet: 4, desktop: 3 }}>
                                <div ref={this.scrollRef} className="right-input-box-contact mtb1-contact">
                                    <Input
                                        className="input-contact"
                                        label="Last Name"
                                        name="lastName"
                                        width={'100%'}
                                        value={this.state.contactInformation.lastName}
                                        onChange={(e) => this.isValidContactUsInfoField('lastName', e.target.value)}
                                        error={!!this.state.errorTexts.contactInformation.lName}
                                        errorText={this.state.errorTexts.contactInformation.lName} 
                                    />
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col colSizes={{ mobile: 4, tablet: 4, desktop: 3 }}>
                                <div className="left-input-box-contact mtb1-contact">
                                    <Input
                                        className="input-contact"
                                        label="Phone number" 
                                        maxLength="10"
                                        // value={this.state.contactInformation?.Phone?.length === 10 ? this.state.contactInformation.Phone.includes('-') ? this.state.contactInformation.Phone : this.state.contactInformation.Phone.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3") : this.state.contactInformation.Phone}
                                        value={this.state.contactInformation?.Phone?.length === 10 ? this.state.contactInformation.Phone.includes('-') ? this.state.contactInformation.Phone : this.state.contactInformation.Phone.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3") : this.state.contactInformation.Phone}
                                        width={'100%'}
                                        onChange={(e) => this.isValidContactUsInfoField('Phone', e.target.value)}
                                        error={!!this.state.errorTexts.contactInformation.cPhoneNumber}
                                        errorText={this.state.errorTexts.contactInformation.cPhoneNumber}
                                        
                                    />
                                </div>
                            </Col>
                            <Col colSizes={{ mobile: 4, tablet: 4, desktop: 3 }}>
                                <div className="right-input-box-contact mtb1-contact">
                                    <Input
                                        className="input-contact"
                                        label="Email"
                                        placeholder="Enter Email"
                                        value={this.state.contactInformation.Email}
                                        onChange={(e) => this.isValidContactUsInfoField('Email', e.target.value)}
                                        error={!!this.state.errorTexts.contactInformation.cEmail}
                                        errorText={this.state.errorTexts.contactInformation.cEmail}
                                        width={'100%'}
                                        maxLength="50"
                                    />
                                </div>
                            </Col>
                        </Row>
                            {/* <Row>
                                <Col colSizes={{ mobile: 4, tablet: 3, desktop: 3 }}>
                                    <div className="left-input-box-contact mtb1-contact">
                                        <Input
                                            className="input-contact"
                                            label="Street Address"
                                            placeholder="Enter street Address"
                                            maxLength="40"
                                            width={'100%'}
                                            value={this.state.contactInformation.Address}
                                            onChange={(e) => this.isValidContactUsInfoField('Address', e.target.value)}
                                            error={this.state.errorTexts.contactInformation.cAddress}
                                            errorText={this.state.errorTexts.contactInformation.cAddress}
                                        />
                                    </div>
                                </Col>
                                <Col colSizes={{ mobile: 4, tablet: 3, desktop: 3 }}>
                                    <div className="right-input-box-contact mtb1-contact">
                                        <Input
                                            className="input-contact"
                                            label="City"
                                            placeholder="enter City"
                                            maxLength="40"
                                            onKeyDown={isAlpha}
                                            width={'100%'}
                                            value={this.state.contactInformation.City}
                                            onChange={(e) => this.isValidContactUsInfoField('City', e.target.value)}
                                            error={this.state.errorTexts.contactInformation.cCity}
                                            errorText={this.state.errorTexts.contactInformation.cCity}                                        />
                                    </div>
                                </Col>
                            </Row> */}
                            <Row>
                                <Col colSizes={{ mobile: 4, tablet: 4, desktop: 3 }}>
                                <div  className="left-input-box-contact mtb1-contact">
                                    <Input
                                        className="input-contact"
                                        label="Business Name"
                                        width="100%"
                                        value={this.state.contactInformation.Company}
                                        onChange={(e) => this.isValidContactUsInfoField('Company', e.target.value)}
                                        error={!!this.state.errorTexts.contactInformation.cBusinessName}
                                        errorText={this.state.errorTexts.contactInformation.cBusinessName}
                                    />
                                </div>
                            </Col>
                                {/* <Col colSizes={{ mobile: 4, tablet: 4, desktop: 3 }}>
                                    <div className="right-input-box-contact mtb1-contact">
                                        <Input
                                            className="input-contact"
                                            label="Industry"
                                            placeholder="Enter Industry"
                                            maxLength="40"
                                            onKeyDown={isAlpha}
                                            width={'100%'}
                                            value={this.state.contactInformation.Industry}
                                            onChange={(e) => this.isValidContactUsInfoField('Industry', e.target.value)}
                                            error={this.state.errorTexts.contactInformation.cIndustry}
                                            errorText={this.state.errorTexts.contactInformation.cIndustry}                                        />
                                    </div>
                                </Col> */}
                            </Row>
                            <Row>
                        {/* <Col colSizes={{ mobile: 4, tablet: 4, desktop: 3 }}>
                                    <div className="left-input-box-contact mtb1-contact">
                                        <Input
                                            className="input-contact"
                                            label="Country"
                                            placeholder="Enter Country"
                                            maxLength="40"
                                            width={'100%'}
                                            value={'United States of America'}
                                            // onChange={(e) => this.isValidContactUsInfoField('Country', e.target.value)}
                                            error={this.state.errorTexts.contactInformation.cCountry}
                                            errorText={this.state.errorTexts.contactInformation.cCountry}
                                        />
                                    </div>
                                </Col> */}
                            {/* <Col colSizes={{ mobile: 4, tablet: 3, desktop: 3 }}>
                               
                            <div className="right-input-box-contact mtb1-contact">
                                        <Input
                                            className="input-contact"
                                            label="Zip code"
                                            placeholder="Enter Zip"
                                            maxLength="5"
                                            width={'100%'}
                                            value={this.state.contactInformation.Zip}
                                            onChange={(e) => this.isValidContactUsInfoField('Zip', e.target.value)}
                                            error={this.state.errorTexts.contactInformation.cZip}
                                            errorText={this.state.errorTexts.contactInformation.cZip}
                                        />
                                    </div>
                            </Col> */}
                        </Row>
                            <Row>
                            <Col colSizes={{ mobile: 4, tablet: 10, desktop: 6 }}>
                                <div className="left-input-box-contact mtb1-contact" >
                                <TextArea 
                                label="Reason for contacting"
                                readOnly={false}
                                required={false}
                                disabled={false}
                                error={false}
                                errorText="Enter a valid Address."
                                helperTextPlacement="bottom"
                                value={this.state.contactInformation.Comments}
                                onChange={(e) => this.isValidContactUsInfoField('Comments', e.target.value)}

                                />
                               
                                </div>
                            </Col>
                        </Row>
                        <MarginSpacerM></MarginSpacerM>
                            <Row>
                            <Col colSizes={{ mobile: 6, tablet: 10, desktop: 6 }}>
                                <div className="mtb1-contact-desc">
                                    <Body size="medium" primitive="h2">
                                    The information provided will be used in accordance with our terms set out in our <a style={{color:'black'}}
                                            href="https://www.verizon.com/about/privacy/"
                                            target="_blank" rel="noopener noreferrer">
                                            Privacy Policy 
                                        </a>. Please confirm you have read and understood the Policy.
										</Body>
                                </div>
                            </Col>
                        </Row>
                        {/* <MarginSpacerM></MarginSpacerM> */}
                        <Row>
                            <Col colSizes={{ mobile: 4, tablet: 10, desktop: 6 }}>
                                <CheckboxGroup
                                    childWidth={'100%'}
                                    viewport={'desktop'}
                                    onChange={(e) => this.setState({ confirmCheckbox: !this.state.confirmCheckbox })}
                                    data={[
                                        {
                                            children: 'I confirm I have read and understood',
                                            width: '100%',
                                            selected: this.state.confirmCheckbox
                                        }
                                    ]}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col colSizes={{ mobile: 6, tablet: 10, desktop: 6 }}>
                                <div className="mtb1-contact-desc">
                                    <Body size="medium" primitive="h2">
                                    Verizon may wish to contact you in the future concerning its products and/or services. If you would like to receive these communications from Verizon, indicate by selecting from the dropdown menu below. Please note that you can <a
                                            style={{color:'black'}}
                                            href="https://info.verizonenterprise.com/UnsubscribePage.html"
                                            target="_blank" rel="noopener noreferrer">
                                            unsubscribe
                                        </a>  or update your <a
                                            style={{color:'black'}}
                                            href="https://enterprise.verizon.com/your-preferences/"
                                            target="_blank" rel="noopener noreferrer">
                                            preferences
                                        </a> at any time.
										</Body>
                                </div>
                            </Col>
                        </Row>
                         <Row>
                                <Col colSizes={{ mobile: 4, tablet: 4, desktop: 3 }}>
                                    <div className="mtb1-drpdwn">
                                        <DropdownSelect
                                            className="input-contact"
                                            id="State"
                                            label="Select Communication Preference"
                                            width={'100%'}
                                            value={this.state.contactInformation.Preference}
                                            onChange={(e) => this.isValidContactUsInfoField('Preference', e.target.value)}
                                        >
                                            <option value="Email">Email</option>
                                            <option value="Phone">Phone</option>
                                        </DropdownSelect>
                                    </div>
                                </Col>
                            </Row>
                        <Row>
                            <Col colSizes={{ mobile: 4, tablet: 3, desktop: 3 }}>
                                <div className="continue-btn">
                                    <Button onClick={e => {this.onContinueClick()}} size="large" disabled={this.state.confirmCheckbox === false}>
                                       Submit
                                    </Button>
                                </div>
                            </Col>
                        </Row>
                        </Grid>
            </div>            
        );
    }
}
const mapStateToProps = state => {
    const { AddressValidationPage} = state;
    return {
        toggleLoadingSpinner: AddressValidationPage.toggleLoadingSpinner,
        addressData: AddressValidationPage
    }
}
const mapDispatchToProps = dispatch => ({
    action: bindActionCreators(action, dispatch),
    SubmitIdeForm: (data, history) => dispatch(SubmitIdeForm(data, history)),
    showSpinner: (data) => dispatch(showSpinner(data))
});

ContactUs = connect(mapStateToProps, mapDispatchToProps)(ContactUs);

export default ContactUs;
